/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import { withLocalization } from 'hocs/localization'
import { onShowNewPlanAcceptedMessage } from 'redux-app/modules/user'
import NewPlanAccepted from './NewPlanAccepted'

export default compose(
  connect(
    null,
    {
      withRouter,
      onShowNewPlanAcceptedMessage,
    },
  ),
  withLocalization('profile.newPlanAccepted'),
  withHandlers({
    onConfirm: ({
      onShowNewPlanAcceptedMessage,
      history: { replace },
    }) => () => {
      onShowNewPlanAcceptedMessage()
      replace(ROUTES.profile.view)
    },
  }),
)(NewPlanAccepted)
